<template>
<div>
  <div class="pt-60 fs-26 bold">{{info.moduleTitle}}</div>
  <ul class="p-type-list guide-mol">
    <li>
      <div @click="toConnection('p1')">
        <img :src="imgObj.p1" v-if="imgObj.p1"/>
      </div>
    </li>
    <li class="li-2">
      <div  @click="toConnection('p2')">
        <img :src="imgObj.p2" v-if="imgObj.p2"/>
      </div>
      <div  @click="toConnection('p3')">
        <img :src="imgObj.p3" v-if="imgObj.p3"/>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    let list = this.info.extra && this.info.extra.pictureInfoList ? this.info.extra.pictureInfoList : []
    let imgObj = {}
    let urlObj = {}
    list.map((o, i) => {
      imgObj[`p${i + 1}`] = o.pictureUrl
      urlObj[`p${i + 1}`] = o.connection
    })
    return {
      imgObj,
      urlObj
    }
  },
  mounted () {
  },
  methods: {
    toConnection (k) {
      if (this.urlObj[k]) {
        window.location.href = this.urlObj[k]
      }
    }
  }
}
</script>
